/**
 * Normalize BFeeSource form/API body for IO.REST.MSG.BFeeSourceReq (%JSONImport).
 * souGid/souRno/bgrRno are response-only — sending them causes IRIS ERROR #9404.
 * Mirrors property types in MBengine_ENS IO.REST.MSG.BFeeSourceReq.cls — 15/09/2026 PK.
 */

const BFEE_INTEGER_FIELDS: readonly string[] = [
  'id',
  'uacId',
  'useRno',
  'useGid',
  'bfgGid',
  'bfgRno',
  'bfsGid',
  'bfsRno',
  'noExtraChargeForSameDay',
  'status',
  'sourceId',
  'bankGroupId',
];

const BFEE_STRING_FIELDS: readonly string[] = ['sourceTransactionDescription'];

function isEmptyValue(value: unknown): boolean {
  return value === '' || value === null || value === undefined;
}

function coerceInteger(value: unknown, defaultZero = false): number | undefined {
  if (isEmptyValue(value)) {
    return defaultZero ? 0 : undefined;
  }
  if (typeof value === 'boolean') {
    return value ? 1 : 0;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.trunc(value);
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') {
      return defaultZero ? 0 : undefined;
    }
    const n = Number(trimmed);
    return Number.isNaN(n) ? undefined : Math.trunc(n);
  }
  return undefined;
}

/**
 * Build a BFeeSourceReq-shaped JSON body safe for createBFee %JSONImport.
 */
export function normalizeBfeeSourceForCreateApi(
  body: Record<string, unknown>
): Record<string, unknown> {
  const out: Record<string, unknown> = {};

  for (const key of BFEE_STRING_FIELDS) {
    if (!(key in body)) {
      continue;
    }
    const v = body[key];
    if (isEmptyValue(v)) {
      continue;
    }
    out[key] = String(v);
  }

  for (const key of BFEE_INTEGER_FIELDS) {
    if (!(key in body)) {
      continue;
    }
    const defaultZero = key === 'noExtraChargeForSameDay' || key === 'bfsGid' || key === 'bfsRno';
    const n = coerceInteger(body[key], defaultZero);
    if (n !== undefined) {
      out[key] = n;
    }
  }

  return out;
}

/**
 * Same whitelist as create — update uses body fields directly but must not send souGid/souRno.
 */
export function normalizeBfeeSourceForUpdateApi(
  body: Record<string, unknown>
): Record<string, unknown> {
  return normalizeBfeeSourceForCreateApi(body);
}
